document.addEventListener("DOMContentLoaded", function () {
  const faqButtons = document.querySelectorAll(".faq-item button");

  faqButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const content = this.nextElementSibling;
      const icon = this.querySelector(".faq-icon");
      const isExpanded = this.getAttribute("aria-expanded") === "true";

      // Toggle content visibility
      if (isExpanded) {
        content.classList.add("hidden");
        // Check if chevron icon exists, if not fall back to plus/minus
        const chevron = icon?.querySelector("svg");
        if (chevron) {
          chevron.style.transform = "rotate(0deg)";
        } else {
          icon.textContent = "+";
        }
        this.setAttribute("aria-expanded", "false");
      } else {
        content.classList.remove("hidden");
        // Check if chevron icon exists, if not fall back to plus/minus
        const chevron = icon?.querySelector("svg");
        if (chevron) {
          chevron.style.transform = "rotate(180deg)";
        } else {
          icon.textContent = "−";
        }
        this.setAttribute("aria-expanded", "true");
      }
    });
  });
});
